import styled from '@emotion/styled'

import Button from '../../../components/Button'
import { MOBILE } from '../../../guided-toolbox/utils/breakpoints'

/** Centers the offboarding actions, keeping the primary action last when they stack. */
export const ButtonGroup = styled.div`
  display: flex;
  justify-content: center;
  flex-wrap: wrap-reverse;
  gap: 16px;
  margin: 36px 0;

  ${MOBILE} {
    flex-direction: column-reverse;
    flex-wrap: nowrap;
    align-items: stretch;
  }
`

export const Heading = styled.div`
  color: ${p => p.theme.darkestGray};
  font-weight: 300;
  font-size: 3rem;
  font-family: 'Open Sans', 'Helvetica Neue', sans-serif;
`

export const Text = styled.div`
  color: #3a4d57;
  font-size: 1.125rem;
  font-family: 'Open Sans', 'Helvetica Neue', sans-serif;
  font-weight: 300;
  line-height: 1.5;
`

export const SubText = styled.div`
  color: #3a4d57;
  font-size: 0.875rem;
  font-family: 'Open Sans', 'Helvetica Neue', sans-serif;
`

export const SubHeading = styled.div`
  color: #051f2c;
  font-size: 1.375rem;
  font-weight: ${p => (p.fontWeight ? p.fontWeight : 300)};
  font-family: 'Open Sans', 'Helvetica Neue', sans-serif;
`

export const OrangeText = styled.span`
  color: #ffa500;
`

/** Displays an enrollment or upgrade choice as a fixed-size tile using the selected button variant. */
export const EnrollTile = styled(Button)`
  width: 160px;
  height: 98px;
  min-width: 0;
  padding: 1px 12px;
  border-radius: 4px;
  font-size: 18px;
  font-weight: 400;
  line-height: 1.35;
`
